/**
 * @desc Yung-OMS包裹拦截(自营，履约系统调用)
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.outMasterFacadeImpl.interceptOutMaster.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/outMaster/interceptOutMaster`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
